export default __webpack_public_path__ + "img/director-photo-2c08b89d.jpg";